<ng-container *transloco="let t">
  @if (user()) {
    <h3 class="mb-8 text-3xl font-semibold text-gray-800 dark:text-gray-100">{{ t("common.reset_password") }}</h3>
    @if (error()) {
      <IAlert class="mb-6 block" type="error" [title]="error()!" />
    }
    <IResetPasswordForm [isLoading]="loading()" (formSubmit)="requestPasswordReset($event)" />
  } @else if (user() === null) {
    <h3 class="mb-8 text-3xl font-semibold text-gray-800 dark:text-gray-100">
      {{ t("password-reset.link_expired") }}
    </h3>
    <p class="mb-6 text-gray-600 dark:text-gray-400">
      {{ t("password-reset.link_expired_description") }}
    </p>
    <a iButton [routerLink]="'/login'" class="w-full" type="button" size="lg">
      {{ t("password-reset.back_to_login") }}
    </a>
  } @else {
    <ISpinner />
  }
</ng-container>
